import { State } from 'models';
import { createDeepEqualSelector } from '../helpers';
import { orderBy } from 'lodash';

const buildingsSelector = (state: State) => state.buildings.buildingsList;

export const getBuildings = createDeepEqualSelector(
  buildingsSelector,
  (buildings) => {
    return orderBy(buildings, ['Order'], ['asc']);
  }
);
